import { updateSharingLinkFromSharingDialog } from '../actions/internalActions';
import getSharingLink from '../selectors/getSharingLink';
import SharingLinkInfo from '../store/schema/SharingLinkInfo';
import { mutator } from 'satcheljs';

mutator(updateSharingLinkFromSharingDialog, actionMessage => {
    const sharingLink: SharingLinkInfo = getSharingLink(actionMessage.linkId);

    // This is not completely accurate since there are other link types like "embed" and "review".
    // But for our purposes, we only care if it's edit or not.
    sharingLink.sharingInfo.linkType = actionMessage.sharingDialogResponse.isEdit ? 'edit' : 'view';
});
